import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import IndiaMap from "./IndiaMap";
import clsx from "clsx";
import { AOSContainer } from "../../../../common/AOSContainer";
import secondTabImage from "../../../../assets/CITIIS_2_18_cities.svg";
// import CitiesMap from "./citiesMap";
const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    height: 900,
    zIndex: 10,
  },
  mapsectionProject:{
    display: 'flex', 
    justifyContent: 'flex-start', 
    marginBottom: '-50px' 
  },
  firstBg: {
    backgroundImage: `url(${require("../../../../assets/backgrounds/citiisbg.png")})`,
    backgroundPosition: "bottom",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: "50%",
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 11,
    transform: "rotate(180deg)",
  },
  secondBg: {
    backgroundImage: `url(${require("../../../../assets/backgrounds/citiisbg.png")})`,
    backgroundPosition: "bottom",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: "50%",
    width: "100%",
    position: "absolute",
    bottom: 0,
    left: 0,
    zIndex: 11,
  },
  mainContainer: {
    position: "absolute",
    height: "100%",
    width: "100%",
    top: 0,
    left: 0,
    backgroundColor: "rgba(0,0,0,0)",
    zIndex: 12,
    padding: "80px 8%",
  },
}));

const OurProjects = () => {
  const classes = useStyles();
  const [trigger, setTrigger] = useState(0);


  return (
    <Paper
      elevation={0}
      className={clsx(classes.root, "newrootmaindivourproj")}
      onClick={() => {
        setTrigger((trigger) => trigger + 1);
      }}
    >
      <Paper elevation={0} className={classes.firstBg}></Paper>
      <Paper elevation={0} className={classes.secondBg}></Paper>

      <Paper className={clsx(classes.mainContainer, "maincontainernewproject")}>



        <Box className="mapsectionProject">
          <AOSContainer animationType="fade-right">
            <Typography
              textAlign="left"
              variant="thinmedium"
              style={{ color: "#525151" }}
            >
              Our
            </Typography>
            <Typography
              textAlign="left"
              variant="thicklarge"
              style={{ color: "#525151" }}
            >
              projects
            </Typography>
          </AOSContainer>
        </Box>


        <Box sx={{ p: 3 }}>
          <AOSContainer animationType="fade-left">
            <IndiaMap trigger={trigger} />
          </AOSContainer>
        </Box>

      </Paper>

    </Paper>
  );
};

export default OurProjects;
